import * as Types from '../../lib/types';

export const AccordionBlockData_1: Types.AccordionBlock = {
  _type: 'accordionBlock',
  _key: 'accordionBlock_1',
  isDarkMode: true,
  title:
    'The Light operating system, LightOS, is built around intentionality & privacy.',
  backgroundMedia: {
    desktop: {
      _type: 'accessibleImage',
      _key: 'accordionBlock_1_backgroundMedia',
      asset: {
        _id: '4mbLCFYcV8erNgQXRciHw4',
        url: '//assets.thelightphone.com/images/static-clouds.jpg',
        metadata: {
          lqip: '',
          dimensions: {
            aspectRatio: 1,
            width: 1000,
            height: 1000
          }
        }
      },
      alt: 'Clouds'
    }
  },
  layout: 'layout-a',
  accordionItems: [
    {
      _type: 'accordionItem',
      _id: 'accordionItem_1',
      title: 'It’s a phone.',
      plainTextBody: [
        'At its core, it is a simple communication device for staying in touch with those that matter most.'
      ],
      image: {
        _type: 'accessibleImage',
        _key: 'accordionItem_1_image',
        asset: {
          _id: 'accordionItem_1_image',
          url: '//assets.thelightphone.com/images/01.PhoneAnimation.gif',
          metadata: {
            lqip: '',
            dimensions: {
              aspectRatio: 1,
              width: 100,
              height: 100
            }
          }
        },
        alt: 'GIF showing the Light Phone III being used for a phone call and texting.'
      }
    },
    {
      _type: 'accordionItem',
      _id: 'accordionItem_2',
      title: 'Just the tools you’ll need.',
      plainTextBody: [
        'LightOS is built around a customizable menu of tools managed from the dashboard website.'
      ],
      image: {
        _type: 'accessibleImage',
        _key: 'accordionItem_2_image',
        asset: {
          _id: 'accordionItem_2_image',
          url: '//assets.thelightphone.com/images/02.ToolboxAnimation.gif',
          metadata: {
            lqip: '',
            dimensions: {
              aspectRatio: 1,
              width: 100,
              height: 100
            }
          }
        },
        alt: 'GIF showing the toolbox feature on the Light Phone III.'
      }
    },
    {
      _type: 'accordionItem',
      _id: 'accordionItem_3',
      title: 'Find your way around the real world.',
      plainTextBody: [
        'With tools like directions, LightOS brings the most useful aspects of technology without endless feeds of distraction.'
      ],
      image: {
        _type: 'accessibleImage',
        _key: 'accordionItem_3_image',
        asset: {
          _id: 'accordionItem_3_image',
          url: '//assets.thelightphone.com/images/03.Directions.png',
          metadata: {
            lqip: '',
            dimensions: {
              aspectRatio: 1,
              width: 100,
              height: 100
            }
          }
        },
        alt: 'Image showing the Light Phone III being used for directions.'
      }
    },
    {
      _type: 'accordionItem',
      _id: 'accordionItem_4',
      title: 'Be intentional, you’re in control.',
      plainTextBody: [
        'Every tool is designed for very intentional utility. No getting lost in a scroll hole.'
      ],
      image: {
        _type: 'accessibleImage',
        _key: 'accordionItem_4_image',
        asset: {
          _id: 'accordionItem_4_image',
          url: '//assets.thelightphone.com/images/04.ToolsAssorted.gif',
          metadata: {
            lqip: '',
            dimensions: {
              aspectRatio: 1,
              width: 100,
              height: 100
            }
          }
        },
        alt: 'GIF showing the assorted tools on the Light Phone III.'
      }
    }
  ],
  cta: {
    _type: 'buttonLink',
    label: 'Read more about how it works',
    link: {
      _type: 'link',
      internal: {
        _id: 'lightiii',
        _type: 'genericPage',
        slug: '/lightiii'
      },
      ariaLabel: 'Learn more about the Light Phone III'
    },
    variant: 'secondary-darkmode'
  },
  showBorderTop: false,
  bottomSpacer: true
};

export const AccordionBlockData_2: Types.AccordionBlock = {
  _type: 'accordionBlock',
  _key: 'accordionBlock_2',
  isDarkMode: true,
  title: 'Going light can be whatever you’d like it to be.',
  backgroundMedia: {
    desktop: {
      _type: 'accessibleImage',
      _key: 'accordionBlock_2_backgroundMedia',
      asset: {
        _id: '1AoNQFwCujgoUKXlSmwc5G',
        url: '//assets.thelightphone.com/images/son_father.jpeg',
        metadata: {
          lqip: '',
          dimensions: {
            aspectRatio: 1,
            width: 1000,
            height: 1000
          }
        }
      },
      alt: 'Son and father laughing while taking a picture of a mini motorcyle with the Light Phone III.'
    }
  },
  layout: 'layout-a',
  accordionItems: [
    {
      _type: 'accordionItem',
      _id: 'accordionItem_1',
      title: 'Stay present during precious moments.',
      plainTextBody: [
        'What are you missing out on when you pull out your smartphone hundreds of times a day? Life is just too short.'
      ],
      backgroundMedia: {
        desktop: {
          _type: 'accessibleImage',
          _key: 'accordionItem_1_backgroundMedia',
          asset: {
            _id: '6vUdrj2B6oETNDikUVZ1PV',
            url: '//assets.thelightphone.com/images/01-desktop.jpg',
            metadata: {
              lqip: '',
              dimensions: {
                aspectRatio: 1,
                width: 1000,
                height: 1000
              }
            }
          },
          alt: 'Son and father laughing while taking a picture of a mini motorcyle with the Light Phone III.'
        },
        mobile: {
          _type: 'accessibleImage',
          _key: 'accordionItem_1_backgroundMedia',
          asset: {
            _id: '206J0kZhnnOZ4VtZcJxAze',
            url: '//assets.thelightphone.com/images/01-mobile.jpg',
            metadata: {
              lqip: '',
              dimensions: {
                aspectRatio: 1,
                width: 1000,
                height: 1000
              }
            }
          },
          alt: 'Son and father laughing while taking a picture of a mini motorcyle with the Light Phone III.'
        }
      }
    },
    {
      _type: 'accordionItem',
      _id: 'accordionItem_2',
      title: 'Take your passions seriously.',
      plainTextBody: [
        'Going light gives you space you need to focus on what really moves and inspires you.'
      ],
      backgroundMedia: {
        desktop: {
          _type: 'accessibleImage',
          _key: 'accordionItem_2_backgroundMedia',
          asset: {
            _id: '3ORFAsJCiQaxzIFj7kwNsv',
            url: '//assets.thelightphone.com/images/02-desktop.jpg',
            metadata: {
              lqip: '',
              dimensions: {
                aspectRatio: 1,
                width: 1000,
                height: 1000
              }
            }
          },
          alt: 'Light Phone II next to a typewriter.'
        },
        mobile: {
          _type: 'accessibleImage',
          _key: 'accordionItem_2_backgroundMedia',
          asset: {
            _id: '46A2E9QzmcmThwX1Qv3ml1',
            url: '//assets.thelightphone.com/images/02-mobile.jpg',
            metadata: {
              lqip: '',
              dimensions: {
                aspectRatio: 1,
                width: 1000,
                height: 1000
              }
            }
          },
          alt: 'Light Phone II next to a typewriter.'
        }
      }
    },
    {
      _type: 'accordionItem',
      _id: 'accordionItem_3',
      title: 'A breath of fresh air.',
      plainTextBody: [
        'It’s so refreshing to break free from your smartphone habits and the perpetual feeling of missing out and needing to check and re-check.'
      ],
      backgroundMedia: {
        desktop: {
          _type: 'accessibleImage',
          _key: 'accordionItem_3_backgroundMedia',
          asset: {
            _id: '1xIZJSBfWY292GiM73es2c',
            url: '//assets.thelightphone.com/images/03-desktop.jpg',
            metadata: {
              lqip: '',
              dimensions: {
                aspectRatio: 1,
                width: 1000,
                height: 1000
              }
            }
          },
          alt: 'Light Phone II on top of a stack of books.'
        },
        mobile: {
          _type: 'accessibleImage',
          _key: 'accordionItem_3_backgroundMedia',
          asset: {
            _id: '3rj8QwBT9SjRLDZtB2afOI',
            url: '//assets.thelightphone.com/images/03-mobile.jpg',
            metadata: {
              lqip: '',
              dimensions: {
                aspectRatio: 1,
                width: 1000,
                height: 1000
              }
            }
          },
          alt: 'Light Phone II on top of a stack of books.'
        }
      }
    }
  ],
  showBorderTop: false
};
